import { CareAppListActionFactory } from '../action-factory';
import { CustomerDto } from '@careapp-group/ng-sdk';

class StaffCustomersActions extends CareAppListActionFactory<CustomerDto> {
  get REQUEST_REMOVE() {
    return `[${this.type}][Request] Remove`;
  }

  get RESPONSE_SUCCESS_REMOVE() {
    return `[${this.type}][Response][Success] Remove`;
  }

  get RESPONSE_FAIL_REMOVE() {
    return `[${this.type}][Response][Fail] Remove`;
  }

  /**
   * Revoke a user's permissions on the currently selected customer
   *
   * @param {{ id: string }} payload The member id to revoke permissions from
   * @returns
   * @memberof StaffCustomersActions
   */
  RequestRemove(payload: { id: string }) {
    return {
      type: this.REQUEST_REMOVE,
      payload,
    };
  }

  ResponseSuccessRemove(payload: { id: string; customerId: string }) {
    return {
      type: this.RESPONSE_SUCCESS_REMOVE,
      payload,
    };
  }

  ResponseFailRemove(payload: { id: string; customerId: string }) {
    return {
      type: this.RESPONSE_FAIL_REMOVE,
      payload,
    };
  }

  constructor() {
    super('StaffCustomers');
  }
}

export const StaffCustomers = new StaffCustomersActions();
